const resourcesTitleSort = (a, b) => {
    if (a) return 0;
    const nameA = a.node.data.title.toUpperCase(); // ignore upper and lowercase
    const nameB = b.node.data.title.toUpperCase(); // ignore upper and lowercase
    if (nameA < nameB) {
        return -1;
    }
    if (nameA > nameB) {
        return 1;
    }
    return 0;
};

/**
 * Trims long titles so they fit on two lines. Long titles show up with an elipsis, shorter titles are returned unedited.
 * @param {string} title of Card
 * @return {string} truncated title
 */
const resourcesTrimTitle = (title) => {
    // Max length for title to fit on two lines, prior to ellipse concat
    const maxLength = 63;
    // Sets max length on title
    const trimmedTitle = title.substring(0, maxLength);
    // If title is greater than max length, return, else return original title
    return title.length > maxLength
        ? trimmedTitle
              // Returns string with last full word (if word after space, returns last space before additional / half words)
              .substr(0, Math.min(trimmedTitle.length, trimmedTitle.lastIndexOf(" ")))
              .concat("...")
        : title;
};

module.exports = {
    resourcesTrimTitle,
    resourcesTitleSort
};
